import { BACKGROUND_OPTIONS_BY_ID } from '../constants/backgroundOptions'

export function getHasDarkBackground(pageNumber, memoryBook) {
  if (!memoryBook || !pageNumber) {
    return false
  }
  const pageData = memoryBook.contentPages?.find((page) => String(page.page) === String(pageNumber))
  const backgroundId = pageData?.backgroundId
  return BACKGROUND_OPTIONS_BY_ID[backgroundId]?.hasDarkBackground ?? false
}
